import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { newsApi } from '../services/api';

function News() {
  const [newsItems, setNewsItems] = useState([]);
  const [hotArticles, setHotArticles] = useState([]);
  const [categories, setCategories] = useState([]);
  const [financialCalendar, setFinancialCalendar] = useState([]);
  const [activeCategory, setActiveCategory] = useState('all');
  const [searchInput, setSearchInput] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        // 获取热门新闻
        const hotNewsResponse = await newsApi.getHotNews();
        if (hotNewsResponse.success && Array.isArray(hotNewsResponse.data)) {
          setNewsItems(hotNewsResponse.data);
          // 前5条作为热门文章
          setHotArticles(hotNewsResponse.data.slice(0, 5).map(item => ({
            id: item.id,
            title: item.title
          })));
        } else {
          // 如果API调用失败或返回的数据不是数组，设置为空数组
          setNewsItems([]);
          setHotArticles([]);
          console.warn('获取热门新闻失败或数据格式不正确');
        }

        // 获取新闻分类
        const categoriesResponse = await newsApi.getNewsCategories();
        if (categoriesResponse.success && Array.isArray(categoriesResponse.data)) {
          setCategories(categoriesResponse.data);
        } else {
          // 如果API调用失败或返回的数据不是数组，设置为空数组
          setCategories([]);
          console.warn('获取新闻分类失败或数据格式不正确');
        }

        // 获取财经日历
        const calendarResponse = await newsApi.getFinancialCalendar();
        if (calendarResponse.success && Array.isArray(calendarResponse.data)) {
          setFinancialCalendar(calendarResponse.data);
        } else {
          // 如果API调用失败或返回的数据不是数组，设置为空数组
          setFinancialCalendar([]);
          console.warn('获取财经日历失败或数据格式不正确');
        }
      } catch (error) {
        console.error('获取新闻数据失败:', error);
        setError('获取新闻失败，请稍后再试');
        // 确保在出错时所有状态都设置为空数组
        setNewsItems([]);
        setHotArticles([]);
        setCategories([]);
        setFinancialCalendar([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleCategoryChange = async (category) => {
    setActiveCategory(category);
    setLoading(true);
    
    try {
      let response;
      if (category === 'all') {
        response = await newsApi.getHotNews();
      } else {
        response = await newsApi.getNewsByCategory(category);
      }
      
      if (response.success && Array.isArray(response.data)) {
        setNewsItems(response.data);
      } else {
        // 如果API调用失败或返回的数据不是数组，设置为空数组
        setNewsItems([]);
        console.warn('获取分类新闻失败或数据格式不正确');
      }
    } catch (error) {
      console.error('获取分类新闻失败:', error);
      setError('获取分类新闻失败，请稍后再试');
      setNewsItems([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = async () => {
    if (!searchInput.trim()) return;
    
    setLoading(true);
    try {
      const response = await newsApi.searchNews(searchInput);
      if (response.success && Array.isArray(response.data)) {
        setNewsItems(response.data);
        setActiveCategory('search');
      } else {
        // 如果API调用失败或返回的数据不是数组，设置为空数组
        setNewsItems([]);
        console.warn('搜索新闻失败或数据格式不正确');
      }
    } catch (error) {
      console.error('搜索新闻失败:', error);
      setError('搜索新闻失败，请稍后再试');
      setNewsItems([]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="container">
        <div className="loading-spinner">加载中...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container">
        {error}
      </div>
    );
  }

  return (
    <div className="container">
      {/* 面包屑导航 */}
      <div className="breadcrumbs">
        <Link to="/">首页</Link> <span>&gt;</span> <span>资讯</span>
      </div>

      <div className="section-card">
        <div className="section-header">市场资讯</div>
        <div className="section-content">
          {/* 搜索栏 */}
          <div className="stock-search" style={{ marginBottom: '20px' }}>
            <input 
              type="text" 
              placeholder="搜索资讯关键词" 
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
            />
            <button onClick={handleSearch}>搜索</button>
          </div>

          {/* 内容区分为左右两栏 */}
          <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
            {/* 左侧主要内容区 */}
            <div style={{ flex: '1', minWidth: '300px' }}>
              <div className="filter-options" style={{ marginBottom: '20px' }}>
                <span>分类: </span>
                <button 
                  className={activeCategory === 'all' ? 'active' : ''}
                  onClick={() => handleCategoryChange('all')}
                >
                  全部
                </button>
                {categories && categories.length > 0 ? (
                  categories.map(category => (
                    <button 
                      key={category.id}
                      className={activeCategory === category.id ? 'active' : ''}
                      onClick={() => handleCategoryChange(category.id)}
                    >
                      {category.name}
                    </button>
                  ))
                ) : (
                  <span>暂无分类数据</span>
                )}
              </div>

              {/* 新闻列表 */}
              <div>
                {newsItems && newsItems.length > 0 ? (
                  newsItems.map(news => (
                    <div key={news.id} style={{ 
                      padding: '15px', 
                      marginBottom: '15px', 
                      backgroundColor: 'white', 
                      border: '1px solid #e1e4e8',
                      borderRadius: '8px',
                      display: 'flex'
                    }}>
                      <div style={{ marginRight: '15px' }}>
                        <img src={news.imageUrl || 'https://via.placeholder.com/120x80'} alt={news.title} style={{ borderRadius: '4px', width: '120px', height: '80px' }} />
                      </div>
                      <div style={{ flex: '1' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                          <span style={{ 
                            backgroundColor: '#eef3fd', 
                            color: '#1e3a8a', 
                            padding: '2px 8px', 
                            borderRadius: '4px', 
                            fontSize: '12px' 
                          }}>
                            {news.category || '未分类'}
                          </span>
                          <span style={{ color: '#666', fontSize: '14px' }}>{news.date || '无日期'}</span>
                        </div>
                        <h3 style={{ marginBottom: '10px', fontSize: '18px' }}>
                          <Link to={`/news/${news.id}`} style={{ color: '#333', textDecoration: 'none' }}>
                            {news.title || '无标题'}
                          </Link>
                        </h3>
                        <p style={{ color: '#666', fontSize: '14px', lineHeight: '1.6' }}>
                          {news.summary || '无摘要'}
                        </p>
                        <div style={{ marginTop: '10px' }}>
                          <Link to={`/news/${news.id}`} style={{ 
                            color: '#1e3a8a', 
                            textDecoration: 'none', 
                            fontSize: '14px',
                            fontWeight: '500'
                          }}>
                            阅读全文 &gt;
                          </Link>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div style={{ 
                    padding: '30px', 
                    textAlign: 'center', 
                    backgroundColor: 'white', 
                    border: '1px solid #e1e4e8',
                    borderRadius: '8px'
                  }}>
                    暂无新闻数据
                  </div>
                )}
              </div>
            </div>
            
            {/* 右侧边栏 */}
            <div style={{ width: '280px' }}>
              {/* 热门文章 */}
              <div className="section-card">
                <div className="section-header" style={{ fontSize: '16px' }}>热门文章</div>
                <div className="section-content">
                  {hotArticles && hotArticles.length > 0 ? (
                    <ul style={{ listStyle: 'none' }}>
                      {hotArticles.map((article, index) => (
                        <li key={article.id} style={{ 
                          padding: '10px 0', 
                          borderBottom: '1px solid #e1e4e8'
                        }}>
                          <Link to={`/news/${article.id}`} style={{ 
                            color: '#333', 
                            textDecoration: 'none',
                            fontSize: '14px'
                          }}>
                            {article.title || '无标题'}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p style={{ padding: '10px', color: '#666' }}>暂无热门文章</p>
                  )}
                </div>
              </div>
              
              {/* 市场日历 */}
              <div className="section-card" style={{ marginTop: '20px' }}>
                <div className="section-header" style={{ fontSize: '16px' }}>财经日历</div>
                <div className="section-content">
                  {financialCalendar && financialCalendar.length > 0 ? (
                    financialCalendar.map((day, index) => (
                      <React.Fragment key={index}>
                        <div style={{ marginBottom: '10px', fontSize: '14px', color: '#666' }}>
                          <strong>{day.date}</strong>
                        </div>
                        <ul style={{ listStyle: 'none', marginBottom: '15px' }}>
                          {day.events && day.events.length > 0 ? (
                            day.events.map((event, eventIndex) => (
                              <li key={eventIndex} style={{ fontSize: '14px', marginBottom: '8px' }}>
                                {event.time && <span style={{ color: '#666', marginRight: '5px' }}>{event.time}</span>}
                                {event.title}
                                {event.importance === 'high' && (
                                  <span style={{ 
                                    backgroundColor: '#fef2f2', 
                                    color: '#dc2626', 
                                    padding: '1px 5px', 
                                    borderRadius: '3px', 
                                    fontSize: '12px',
                                    marginLeft: '5px'
                                  }}>
                                    重要
                                  </span>
                                )}
                              </li>
                            ))
                          ) : (
                            <li style={{ fontSize: '14px', color: '#666' }}>当日无事件</li>
                          )}
                        </ul>
                      </React.Fragment>
                    ))
                  ) : (
                    <p style={{ padding: '10px', color: '#666' }}>暂无财经日历数据</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default News;
